import { Injectable } from '@angular/core';
import { TokenService } from './token.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FacturationService {

  constructor(private tokenService : TokenService, private http : HttpClient) { }


  getNbFiches(dateDebut: string, dateFin : string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/facturation/generale?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin);
    
    return this.http.get(request, {headers : httpHeaders});
  }


  getNbFichesAll() {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/facturation/generale-all";
    
    return this.http.get(request, {headers : httpHeaders});
  }

  getFichesFacturables(dateDebut: string, dateFin : string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/facturation/liste-a-facturer?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin);
    
    return this.http.get(request, {headers : httpHeaders});
  }


  getListeValidees(dateDebut: string, dateFin : string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/facturation/liste-valides?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin);
    
    return this.http.get(request, {headers : httpHeaders});
  }


  getListeAttente(dateDebut: string, dateFin : string) {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/facturation/liste-attente?debut=" + escape(dateDebut) + "&fin=" + escape(dateFin);
    
    return this.http.get(request, {headers : httpHeaders});
  }


  getFichesAttenteImportant() {
    let httpHeaders = this.tokenService.loadToken();
    let request = "/api/facturation/attente-important";
    
    return this.http.get(request, {headers : httpHeaders});
  }


  facturerFiches(liste:any[], idResponsable : string) {
    let httpHeaders = this.tokenService.loadToken();
    var request = "/api/facturation/facturer";
    var jsonObject = {liste : liste, responsable : idResponsable};
    return this.http.post(request, jsonObject, {headers : httpHeaders});
  }

}
